module.exports = __webpack_public_path__ + "static/img/23.60a6cb5f.png";